import { useI18n } from "../../i18n";
import { fmtDate, fmtMoney } from "../../lib/format";
import { StatusBadge } from "./StatusBadge";

export const OrdersList = ({ orders, customersByCode, testId = "orders-list" }) => {
  const { t } = useI18n();
  if (!orders.length) return <p className="py-8 text-center text-sm text-slate-500">{t("common.empty")}</p>;
  return (
    <ul data-testid={testId} className="divide-y divide-slate-100">
      {orders.map((o) => (
        <li key={o.local_id} data-testid={`order-row-${o.local_id}`} className="flex items-center gap-3 py-3.5">
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-x-2 text-sm font-semibold text-navy">
              <span>{o.softone_doc_no || "—"}</span>
              {customersByCode && <span className="truncate font-normal text-slate-500">· {customersByCode[o.customer_code]?.name}</span>}
            </div>
            <div className="mt-0.5 text-xs text-slate-500">
              {fmtDate(o.order_date)} · {o.lines.length} {t("staff.items").toLowerCase()}
            </div>
          </div>
          <div className="flex flex-col items-end gap-1">
            <span className="text-sm font-semibold tabular-nums text-navy">{fmtMoney(o.gross_total)}</span>
            <StatusBadge status={o.status} />
          </div>
        </li>
      ))}
    </ul>
  );
};
